export default __webpack_public_path__ + "static/media/image_news.f16b9c68.png";